<style>
    .ui.menu {
        box-shadow: none;
    }

    .chart {
        height: 450px;
    }

    .borderless2 {
        border: 0px 2px 4px rgba(0, 0, 0, 0.18) !important
    }
</style>
<template>
    <div>
        <div class="ui divider"></div>

        <div style="padding-bottom:10px;">
            <div class="brew_snapshot ui dropdown float-right" v-if="isOwner">
                <i class="ellipsis horizontal icon"></i>
                <div class="left menu">
                    <a class="item" :href="urls.tiltDataEdit">Edit Tilt Data</a>
                    <div class="divider"></div>
                    <div class="header">
                        Export To
                    </div>
                    <a class="item" :href="urls.export" target="_blank">CSV File</a>
                    <a class="item" @click.prevent="exportPNG">Image</a>
                </div>
            </div>
            <h4 class="ui header">
                Brew Readings
            </h4>
        </div>
        <highstock :options="options" ref="highcharts" />
    </div>

</template>
<script>
    import VueHighcharts from 'vue-highcharts';

    import Highcharts from 'highcharts';
    import loadStock from 'highcharts/modules/stock';
    import loadExporting from 'highcharts/modules/exporting';
    import loadOfflineExporting from 'highcharts/modules/offline-exporting';
    import Raven from 'raven-js';

    loadStock(Highcharts);
    loadExporting(Highcharts);
    loadOfflineExporting(Highcharts);

    import moment from "moment";
    import { FormatSGForDisplay } from "../../helpers/recipeDisplayHelpers";
    import { mapState, mapGetters } from 'vuex'
    import * as common from "../../utils/common";

    import Vue from 'vue';
    import axios from "axios";

    let tempC = [], tempF = [], sgData = [];

    let saveCommentModal = null;

    Vue.use(VueHighcharts, { Highcharts });

    export default {
        name: "BrewSnapshotChart",
        data() {
            return {
                values: [],
                tempData: [],
                sgData: [],
                options: chartOptions,
                timestamp: null
            }
        },
        computed: {
            ...mapState(["currentUser", "brewId", "brew", "urls"]),
            ...mapGetters(["isMetric", "isCelcius", "isOwner"]),
            snapshot: function () {
                return this.values;
            },
            lastUpdated() {
                return `updated ${moment(this.ts).fromNow()}`;
            }
        },
        watch: {
            "isCelcius": function (val, oldVal) {
                var chart = this.$refs.highcharts.chart;
                var temp = chart.series[0];

                if (val == true) {

                    if (tempC.length == 0) {
                        tempC = tempF.map(val => {
                            return [val[0], common.fahrenheitToCelsius(val[1])];
                        });
                    }

                    temp.setData(tempC, true, false, false);

                } else {

                    temp.setData(tempF, true, false, false);
                }

            }
        },
        created() {

        },
        methods: {
            exportPNG(event) {
                var chart = this.$refs.highcharts.chart;
                chart.exportChart();
            },
            getCelcius() {

            },
            updateChart() {
                var chart = this.$refs.highcharts.chart;

                chart.showLoading('Loading data from server...');

                var temp = chart.series[0],
                    sg = chart.series[1];

                if (this.isCelcius) {
                    if (tempC.length == 0) {
                        tempC = tempF.map(val => {
                            return [val[0], common.fahrenheitToCelsius(val[1])];
                        });
                    }
                    temp.setData(tempC, false);
                } else {
                    temp.setData(tempF, false);
                }

                sg.setData(sgData, false);

                chart.redraw(false);

                chart.hideLoading();
            },
            loadChartData() {
                var self = this;

                var chart = this.$refs.highcharts.chart;

                chart.showLoading('Loading data from server...');

                axios
                    .get(`/api/brews/${self.brewId}/sessions/latest/readings?ts=${self.timestamp}`)
                    .then((response) => {
                        tempF = response.data.temperature || [];
                        sgData = response.data.gravity;

                        self.timestamp = response.data.timestamp;
                        tempC = [];

                        self.updateChart();

                        if (response.data.temperature != null) {

                            const firstTimestamp = response.data.temperature[0][0],
                                lastTimestamp = response.data.temperature[response.data.temperature.length - 1][0];

                            if (moment(lastTimestamp).diff(firstTimestamp, 'h') > 36) {
                                chart.xAxis[0].setExtremes(
                                    moment(lastTimestamp).subtract(24, 'h').valueOf(),
                                    lastTimestamp
                                );
                            }
                        }

                        chart.hideLoading();
                    })
                    .catch((err) => {
                        console.log(err);
                        Raven.captureException(err);
                        Raven.showReportDialog();
                    });
            }

        },
        mounted() {
            var self = this;

            $(".brew_snapshot.ui.dropdown").dropdown();

            Highcharts.setOptions({
                global: {
                    useUTC: false
                }
            });

            var chart = this.$refs.highcharts.chart;

            chart.yAxis[1].min = common.round(this.brew.specification.fg * 1.002, 3);
            chart.yAxis[1].max = common.round(this.brew.specification.og * .998, 3);

            chart.yAxis[1].addPlotLine({
                value: this.brew.specification.fg,
                color: '#aaa',
                width: 2,
                dashStyle: 'shortdash',
                id: 'estFg',
                label: {
                    text: 'Est FG - ' + this.brew.specification.fg + ' SG'
                }
            });

            chart.yAxis[1].addPlotLine({
                value: this.brew.specification.og,
                color: '#aaa',
                width: 2,
                dashStyle: 'shortdash',
                id: 'estOG',
                label: {
                    text: 'Est SG - ' + this.brew.specification.og + ' SG'
                }
            });

            // update the last time it was updated
            chart.credits.update({ text: `updated ${moment(this.ts).fromNow()}` });

            setInterval(() => {
                chart.credits.update({ text: `updated ${moment(this.ts).fromNow()}` });
            }, 60000);

            this.loadChartData();
        },
        beforeDestroy() {
            if (this.target) {
                this.target.destroy();
            }
        }
    }

    const chartOptions = {
        chart: {
            type: 'spline',
            zoomType: 'x',
            panning: true,
            panKey: 'shift',
            animation: false,
            backgroundColor:'rgba(255, 255, 255, 0.0)'
        },
        navigation: {
            buttonOptions: {
                enabled: false
            }
        },
        credits: {
            enabled: true,
            text: "Updating...", //"updated " + moment(this.brewItem.lastReading.currentTimestamp).fromNow(),
            href: null,
            style: {
                cursor: "default",
                color: "#666"
            },
            position: {
                y: -5,
                //    x: -30
            }
        },
        scrollbar: {
            enabled: false
        },
        navigator: {
            enabled: true
        },
        rangeSelector: {
            enabled: false,
        },
        title: {
            text: null
        },
        legend: {
            enabled: false,
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical'
        },
        yAxis: [{
            labels: {
                align: 'right',
                x: -3
            },
            title: {
                text: 'Temp'
            },
            height: '50%',
            lineWidth: 2,
            offset: 5
            //min: 0
        }, {
            labels: {
                align: 'right',
                x: -3
            },
            title: {
                text: 'Gravity'
            },
            //max: (Math.max(self.brewItem.estimatedStats.estOg, self.brewItem.lastReading.currentSGValue) * 1.002).toFixed(3),
            //min: (Math.min(self.brewItem.estimatedStats.estFg, self.brewItem.lastReading.currentSGValue) * .998).toFixed(3),
            top: '55%',
            height: '45%',
            offset: 5,
            lineWidth: 2
            //min: 0
        }],
        xAxis: {
            type: 'datetime',
            ordinal: false,
            tickInternval: 24 * 3600 * 1000,
            //dateTimeLabelFormats: {
            //    day: '%e of %b'
            //},
            units: [[
                'millisecond', // unit name
                [1, 2, 5, 10, 20, 25, 50, 100, 200, 500] // allowed multiples
            ], [
                'second',
                [1, 2, 5, 10, 15, 30]
            ], [
                'minute',
                [1, 2, 5, 10, 15, 30]
            ], [
                'hour',
                [1, 2, 3, 4, 6, 8, 12]
            ], [
                'day',
                [1]
            ], [
                'week',
                [1]
            ], [
                'month',
                [1, 3, 6]
            ], [
                'year',
                null
            ]]
            //labels: {
            //    formatter: function () {
            //        return Highcharts.numberFormat(this.value / 1000, 3);
            //    }
            //}
        },
        plotOptions: {
            series: {
                animation: false,
                connectNulls: false,
                //gapUnit: 'unit',
                //gapSize: 1500,
                //pointInterval: 24 * 3600 * 1000,
                marker: {
                    enabled: true
                }
            }
        },
        series: [{
            type: 'spline',
            name: 'Temp',
            data: [],
            yAxis: 0,
            tooltip: {
                valueDecimals: 1
            },
            color: "rgb(41,170,41)",
            showInNavigator: false,
            allowPointSelect: true
        }, {
            type: 'spline',
            name: 'SG',
            data: [],
            yAxis: 1,
            tooltip: {
                valueDecimals: 3
            },
            color: "rgb(0, 0, 139)",
            showInNavigator: true,
            allowPointSelect: true
        }],
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 375
                },
                chartOptions: {
                    chart: {
                        height: 350
                    },
                    subtitle: {
                        text: null
                    },
                    navigator: {
                        enabled: true
                    },
                    plotOptions: {
                        series: {
                            animation: false,
                            marker: {
                                enabled: false,
                                radius: 4
                            }
                        }
                    },
                    yAxis: [{
                        labels: {
                            align: 'left',
                            x: 3,
                            staggerLines: 2
                        },
                        title: {
                            enabled: false
                        }
                    }, {
                        labels: {
                            align: 'left',
                            x: 3,
                            staggerLines: 2
                        },
                        title: {
                            enabled: false
                        }
                    }],
                    legend: {
                        enabled: true,
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    }
                }
            }]
        }
    };

</script>


// WEBPACK FOOTER //
// src/sections/brew/BrewSnapshotChart.vue